import React, { useContext } from "react"

import {
  timesActivity,
  numWinners
} from "../../../constants/activity-constants"
import { Context } from "./../../../context/app-context"
import useMediaQuery from "./../../../utils/useMediaQuery"

import imgHomeTitle from "./../../../assets/images/home_1.png"
import imgHomeActivityLogo from "./../../../assets/images/encuentra_la_pareja.png"
import imgHomeActivityLogoPc from "./../../../assets/images/encuentra_la_pareja_pc.png"
import elPoder from "./../../../assets/images/elPoder.png"
import imgQueEsperas from "./../../../assets/images/que_esperas.png"
import imgBodegon from "./../../../assets/images/home_bodegon.png"
import imgCardsGame from "./../../../assets/images/home_cards.png"
import icon20 from "./../../../assets/images/icon20.png"

import logoCampana from "./../../../assets/images/logoCampana.png"

import "./home.scss"

export default function Home() {
  const isMobile = useMediaQuery(1300)
  const { dispatch } = useContext(Context)

  const handleModalOpen = () => {
    dispatch({
      type: "set-context",
      payload: {
        modalActive: {
          type: "unauthenticated",
          props: {}
        }
      }
    })
  }

  return (
    <div className="home">
      <div className="home-container">
        <div className="section section-1">
          {/* {(isMobile && (
            <>
              <img className="imgHomeTitle" src={imgHomeTitle} alt="Title" />
              <img
                className="imgHomeActivityLogo"
                src={imgHomeActivityLogo}
                alt="Logo de actividad"
              />
            </>
          )) || ( */}
          <>
            <img className="imgUnJuego" src={logoCampana} alt="campana logo" />
            <h2 className="family-Bw-Black size-24 color-blue">
              La Zona V de la mujer <br /> es poderosa
            </h2>
            <h3 className="family-H-Medium size-20 color-blue">
              Déjanos acompañarte a encontrar <br /> un mundo de confianza,
              aprender <br />
              sobre tu cuerpo para eliminar <br /> tabúes y descubrir
            </h3>
            <img
              className="imgHomeActivityLogo"
              src={elPoder}
              alt="Logo de actividad"
            />
            <h2 className="family-Bw-Black size-25 color-blue">¿Tu misión?</h2>
            <h3 className="family-H-Medium size-20 color-blue">
              ¡Poner a prueba <br /> tu memoria!
            </h3>
          </>
          {/* )} */}
        </div>
        <div className="section section-2">
          {!isMobile && (
            <img
              className="imgCardsGame"
              src={imgCardsGame}
              alt="iconos de actividad"
            />
          )}
          <div className="info-points">
            <p>
              <span className="family-Bw-Black size-35 color-white">
                Canjea{" "}
              </span>{" "}
              {/* <span className="circle-points color-yellow family-Bw-Black size-30">
                20
              </span>{" "} */}
            </p>
            <img className="imgIcon20" src={icon20} alt="puntos a redimir" />
            {/* <p>
              <span className="family-Bw-Black color-yellow size-26">
                PUNTOS{" "}
              </span>{" "}
              <br />
              <span className="family-Bw-Black color-white size-18">
                Y PARTICIPA!
              </span>
            </p> */}
          </div>
          <p className="date-limit family-H-Medium color-white size-18">
            {/* Puedes participar del {timesActivity.inicio.dia} de{" "}
            {timesActivity.inicio.mes} al {timesActivity.fin.dia} de{" "}
            {timesActivity.fin.mes} de {timesActivity.fin.año}. */}
            Encuentra todas las parejas del Mundo Nosotras en tiempo record,
            aprende mientras te diviertes y participa las veces que quieras.
          </p>
          <button
            onClick={handleModalOpen}
            className="CTA btn-primary f-concentrate-home-btn"
          >
            ¡QUIERO JUGAR!
          </button>
        </div>
        <div className="section section-3">
          {/* <img
            className="imgQueEsperas"
            src={imgQueEsperas}
            alt="¿Qué esperas?"
          /> */}
          <h2 className="family-Bw-Black size-24 color-white">
            Del top 1 al {numWinners} <br />
            ganarán
          </h2>
          {/* <p className="paragraph family-H-Medium size-18 color-white">
            Demuestra que eres una experta en nuestro mundo y sé una de las
          </p>
          <p className="paragraph family-H-Medium size-20 color-yellow">
            {numWinners} GANADORAS
          </p> */}
          <img className="imgBodegon" src={imgBodegon} alt="Premios" />
          <p className="paragraph family-H-Medium size-20 color-white">
            <span className="bold color-white size-18">
              Un Increíble Kit
            </span>{" "}
            <br />
            <span className="bold color-white size-18">
              Zona V
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}
